import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=29302d55&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=29302d55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29302d55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29302d55')) {
      api.createRecord('29302d55', component.options)
    } else {
      api.reload('29302d55', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=29302d55&scoped=true&", function () {
      api.rerender('29302d55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/profile/ChangePassword.vue"
export default component.exports